export const mapSize = { x: 56, y: 70 };
export const tileSize = 16;
export const spriteSize = 64;